const COLLECT_PHONE_NUMBER_KEY = 'tamara-finished-collect-phone-number'

const cacheFinishedCollectPhoneNumber = (status) => {
  localStorage.setItem(COLLECT_PHONE_NUMBER_KEY, `${status}`)
}

const getFinishCollectPhoneNumberFromCache = () => {
  const value = localStorage.getItem(COLLECT_PHONE_NUMBER_KEY) || ''

  return value || ''
}

export { cacheFinishedCollectPhoneNumber, getFinishCollectPhoneNumberFromCache }
